import { getMentionsPlugin } from 'hubspot-prosemirror/prosemirror/plugins/MentionsPlugin';
import { TAG_MENTION } from 'hubspot-prosemirror/prosemirror/utils/mentionsUtil';
import PortalIdParser from 'PortalIdParser';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function SnippetsNotFound() {
  return /*#__PURE__*/_jsxs("div", {
    className: "suggestion-item",
    children: [/*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "draftPlugins.snippetsPlugin.resultsZeroState.text"
    }), /*#__PURE__*/_jsx("hr", {
      className: "m-bottom-0"
    }), /*#__PURE__*/_jsx("a", {
      href: `/snippets/${PortalIdParser.get()}/new`,
      target: "_blank",
      rel: "noopener noreferrer",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "draftPlugins.snippetsPlugin.resultsZeroState.link"
      })
    })]
  });
}
SnippetsNotFound.displayName = 'SnippetsNotFound';
export const configureSnippetsPlugin = ({
  snippetFunctions,
  contactEmail,
  contactVid,
  supplementalObjects,
  usePlaintextMode
}) => getMentionsPlugin({
  getSuggestions: (text, done) => {
    snippetFunctions.searchSnippets({
      count: 20,
      offset: 0,
      query: text
    }).then(snippets => {
      const transformedSnippets = snippets.get('results').toJS().map(snippet => ({
        searchText: snippet.name,
        text: snippet.name,
        id: snippet.contentId
      }));
      done(transformedSnippets);
    }).catch(error => {
      Raven.captureException(new Error(`Error occurred in getMentionsPlugin: ${error.message}`), {
        extra: {
          text,
          error
        }
      });
    });
  },
  fetchSelectSuggestion: ({
    snippet,
    handleInsert
  }) => {
    return snippetFunctions.fetchRenderedContent({
      id: snippet.id,
      contactEmail,
      contactVid,
      supplementalObjects
    }).then(data => handleInsert({
      html: data.htmlBody
    }));
  },
  type: TAG_MENTION,
  NotFoundComponent: SnippetsNotFound,
  usePlaintextMode
});